import styles from './Container.module.css'

const Container = (props) => {
  return (<div className={`${styles.container} ${styles[props.customClass]} ${props.fluid ? styles.fluid : ''}`}>{props.children}</div>
  )
}

export default Container